import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { useState, useEffect, useRef } from "react";
import axiApi from "ApiCaller";
import { arrayChoicesToObject } from "views/utils/MutateValues";
import { useTranslation } from "react-i18next";
ChartJS.register(ArcElement, Tooltip, Legend);

const DoughtActiveAlerts = () => {
    const [data, setData] = useState([]);
    const [labels, setLabels] = useState([]);
    const [colors, setColors] = useState([]);
    const [total, setTotal] = useState(0);
    const [tooltipData, setTooltipData] = useState([]);
    const { t: _Tc } = useTranslation("choices");
    const wastes = useRef({});
    const downloads = useRef({});
    const types = useRef({});
    // a6c3d1
    // 0xa6
    const baseColor = "c3d1";
    //const color = useRef(a6c3d1)

    const DataGraph = {
        labels: labels,
        datasets: [
            {
                label: "Alertas activas",
                data: data,
                backgroundColor: colors,
                hoverOffset: 10,
                tooltipData: tooltipData,
            },
        ],
    };
    const OptionsGraph = {
        plugins: {
            legend: {
                position: "top",
                labels: {
                    usePointStyle: true,
                    pointStyle: "rect",
                    font: {
                        size: 10,
                    },
                },
            },
            title: {
                display: true,
                text: "Alertas activas",
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => {
                        const dataset = tooltipItem.dataset;
                        const dataObj = dataset.tooltipData[tooltipItem.dataIndex];
                        if (!dataObj) return "";
                        let percentage = ((dataObj.count / total) * 100).toFixed(2);
                        return [
                            `Tipo: ${dataObj.name}`,
                            `Cantidad: ${dataObj.count} (${percentage}%)`,
                            `Dispositivos con alerta: ${dataObj.devicesCount}`
                        ];
                    },
                },
            },
        },
    };

    const generateColor = (index) => {
        const colorsList = ["#E8E8E8", "#FFF09F", "#D1EAFF", "#89D894", "#E2B78C",
            "#F4AB75", "#C298EB", "#D1D3D3", "#b1b1b1", "#838383"];
        return colorsList[index % colorsList.length];
    };

    useEffect(() => {
        axiApi
            .get(`/api/home/alerts/`)
            .then((resp) => {
                if (resp.data.status) {
                    wastes.current = arrayChoicesToObject(resp.data.params.filters.waste);
                    downloads.current = arrayChoicesToObject(
                        resp.data.params.filters.download
                    );
                    types.current = arrayChoicesToObject(resp.data.params.filters.type);

                    const fetchedItems = resp.data.items || [];

                    const activeAlerts = fetchedItems.filter(item => !item.resolved_at);

                    const typeStats = {};
                    activeAlerts.forEach(item => {
                        if (!typeStats[item.type]) {
                            typeStats[item.type] = {
                                count: 0,
                                devices: new Set()
                            };
                        }
                        typeStats[item.type].count += 1;
                        if (item.device_uuid) {
                            typeStats[item.type].devices.add(item.device_uuid);
                        }
                    });

                    const newLabels = [];
                    const newData = [];
                    const newColors = [];
                    const customTooltips = [];
                    let newTotal = 0;

                    Object.keys(typeStats).forEach((type, index) => {
                        const stat = typeStats[type];
                        const name = _Tc("alerts_types." + type);
                        newLabels.push(name);
                        newData.push(stat.count);
                        newColors.push(generateColor(index));
                        newTotal += stat.count;

                        customTooltips.push({
                            name: name,
                            count: stat.count,
                            devicesCount: stat.devices.size
                        });
                    });

                    setLabels(newLabels);
                    setData(newData);
                    setColors(newColors);
                    setTotal(newTotal);
                    setTooltipData(customTooltips);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            });
    }, []);



    return (
        <div className="border pb-3" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Doughnut data={DataGraph} options={OptionsGraph} />
        </div>
    );
};
export default DoughtActiveAlerts;